// extracted by mini-css-extract-plugin
export default {"app":"App_app__b8XEN","main":"App_main__qsbCA"};